import { useEffect, useState } from 'react'

/**
 * True while the viewport matches `query`. Safe on the server and in environments
 * with no `matchMedia`, where it reports false rather than throwing.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => evaluate(query))

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const list = window.matchMedia(query)
    const update = () => setMatches(list.matches)
    update()
    list.addEventListener('change', update)
    return () => list.removeEventListener('change', update)
  }, [query])

  return matches
}

/**
 * From this width the word panel has somewhere to go beside the passage. Below it
 * there is no gutter worth the name, so the lookup stays an anchored popover.
 */
export const WIDE_QUERY = '(min-width: 1280px)'

/** True on a screen wide enough to put the word panel beside the passage. */
export function useIsWide(): boolean {
  return useMediaQuery(WIDE_QUERY)
}

function evaluate(query: string): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia(query).matches
}
